import React, { useMemo } from 'react'
import GridSpinner from 'components/UI/GridSpinner'
import styles from 'modules/Services/Network/network.module.scss'
import { Button, Grid, Icon, NetworkIcon, Typography } from 'gu-ui-kit'
import formatMoney from 'utils/formatMoney'
import clsx from 'clsx'
import CreateAccountButton from 'modules/Services/Network/subcomponents/CreateAccountButton'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import InstrumentsButtons from 'modules/Services/Network/subcomponents/InstrumentsButtons'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const NetworkBalanceColumn = ({ networkType, homepage_link, className = '' }) => {
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()

  const {
    display_balance = true, loading, balance, bulk_account_creation_allowed,
  } = useSelector((state) => state['services/network'])

  const buttonSize = useMemo(() => {
    if (!breakpoints.lg) {
      return 'm'
    } else if (!breakpoints.xxl) {
      return 's'
    } else {
      return 'm'
    }
  }, [breakpoints])

  return (
    <Grid
      className={className}
      gap={32}
      direction={'column'}
      md={{ direction: 'row', wrap: false }}
      lg={{ direction: 'column', wrap: true }}
    >
      <Grid
        gap={24}
        direction={'column'}
      >
        <div>
          <Grid
            direction={'row'}
            gap={16}
            wrap={false}
            fluid={false}
          >
            <Grid>
              <NetworkIcon
                name={networkType}
                rounded
                size={'m'}
              />
            </Grid>
            <Grid
              direction={'column'}
              gap={4}
            >
              <Typography
                variant={'Subtitle-30'}
                noWrap
              >
                {t('services::networks.' + networkType)}
              </Typography>
              {homepage_link && (
                <Button
                  noWrap
                  size={'s'}
                  component={'a'}
                  href={homepage_link}
                  target={'_blank'}
                  rel="noreferrer"
                  variant={'ghost'}
                  link
                  color={'Label-Secondary'}
                >
                  <Typography variant={'Body-Forms-15'}>{t('services::about_network')}</Typography>
                  <Icon
                    name={'follow-link'}
                    width={16}
                  />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>

        {loading ? (
          <GridSpinner
            color={'inherit'}
            className={styles['network-item__balance']}
          />
        ) : (
          display_balance && (
            <Typography
              component={'div'}
              className={styles['network-item__balance']}
              variant={'Body-Accent-80'}
              dangerouslySetInnerHTML={{
                __html:
                  balance && balance?.amount !== null
                    ? formatMoney(balance.amount, balance.currency)
                    : '',
              }}
            />
          )
        )}
      </Grid>

      <Grid
        className={clsx(styles['network-item__actions-container'])}
        direction={'column'}
        gap={16}
      >
        <CreateAccountButton
          bulkAccountCreationAllowed={bulk_account_creation_allowed}
          buttonSize={buttonSize}
        />
        <InstrumentsButtons
          networkType={networkType}
          buttonSize={buttonSize}
        />
      </Grid>
    </Grid>
  )
}

export default NetworkBalanceColumn

NetworkBalanceColumn.propTypes = {
  networkType: PropTypes.string,
  homepage_link: PropTypes.string,
  className: PropTypes.string,
}
